/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContentEntitlementName {
    TEAMSNAP_PLUS_CONTENT = 'teamsnap_plus_content',
    ENABLE_FLAG_FOOTBALL_CONTENT = 'enable_flag_football_content',
}
